import { ruleRunner } from 'validations/ruleRunner';
import { arrayMinLength } from 'validations/rules';

const Validations = [ruleRunner('deliveries', 'entregas', arrayMinLength(1))];

export default Validations;
